<template>
  <footer class="footer">
    <div class="footer__content main__container">
      <div class="footer__logo">
        <img src="../assets/logos/Brand.svg" alt="tich" width="160" height="65" />
      </div>
      <div class="footer__more">
        <ul>
          <li>
            <h4 class="text__header_4 text__accent spacing__pb_2">
              {{ $t('footer.explore') }}
            </h4>
          </li>
          <li>
            <p class="text__content text__accent">
              {{ $t('footer.documentation') }}
            </p>
          </li>
          <li>
            <a
              href="https://app.tich.academy"
              target="_blank"
              style="text-decoration: none;"
              class="text__content text__accent"
            >
              {{ $t('footer.login') }}
            </a>
          </li>
        </ul>
        <ul>
          <li>
            <h4 class="text__header_4 text__color_primary spacing__pb_2">
              {{ $t('footer.contact_us') }}
            </h4>
          </li>
          <li>
            <a
              href="mailto:support.tich@bunsan.io"
              style="text-decoration: none;"
              class="text__content text__accent"
            >
              {{ $t('footer.contact_email') }}
            </a>
          </li>
          <li>
            <p class="text__content text__accent">
              {{ $t('footer.date') }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: white;
  padding-top: 84px;
  padding-bottom: 104px;

  &__content {
    display: flex;
    justify-content: space-between;
  }

  &__more {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 72px;

    & ul li {
      list-style: none;
      padding: 0;
    }
  }
}

@media only screen and (max-width: 768px) {
  .footer {
    padding-top: 24px;
    padding-bottom: 24px;
    &__content {
      flex-flow: column;
      justify-content: center;
      align-items: center;
    }

    &__more {
      column-gap: 16px;
      margin-top: 24px;
    }
  }
}
</style>
